<template>
  <cascader
    v-bind="attrs"
    :class="[bem.b(), bem.is(isGray ? 'gray-cascader' : '')]"
    :popup-class-name="bem.e('dropdown')"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
    <!-- <template v-if="suffixIcon" #suffixIcon>
      <ll-icon v-if="showAllow" :icon-name="suffixIcon" />
    </template> -->
  </cascader>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { Cascader } from 'ant-design-vue'
import { useAttrs } from 'vue'
import { cascaderProps } from './cascader'
defineOptions({ name: 'LlCascader' })
const bem = createNamespace('cascader')
const attrs = useAttrs()

defineProps(cascaderProps)
</script>
